import { Counter } from "../components/Counter";
import { Reveal } from "../components/Reveal";

const STATS = [
  { to: 98, suffix: "%", label: "Pass Rate" },
  { to: 2500, suffix: "+", label: "Learners taught" },
  { to: 37, suffix: "+", label: "Years Experience" },
  { to: 8, suffix: "", label: "DVSA approved instructors" },
];

export function TrustBadges() {
  return (
    <section className="relative -mt-6 z-10" data-testid="stats-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="card-soft grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-neutral-100 overflow-hidden">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="text-center py-8 px-4">
                <p className="font-heading text-4xl sm:text-5xl font-extrabold brand-text">
                  <Counter to={s.to} suffix={s.suffix} />
                </p>
                <p className="mt-2 text-sm text-neutral-500 font-medium">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
